import { useState } from "react";
import { Loader2 } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useInstitutionAuthorityMutations } from "../hooks";
import type { AuthorityWithPerson } from "../types";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  authority: AuthorityWithPerson;
  institutionId: string;
}

export function EndAuthorityDialog({ isOpen, onClose, authority, institutionId }: Props) {
  const [endedAt, setEndedAt] = useState(() => new Date().toISOString().slice(0, 10));
  const [saving, setSaving] = useState(false);
  const { end } = useInstitutionAuthorityMutations(institutionId);

  const personName =
    authority.minister?.full_name ??
    authority.institution_member?.full_name ??
    "esta persona";

  async function handleSave() {
    setSaving(true);
    try {
      await end(authority.id, endedAt);
      onClose();
    } finally {
      setSaving(false);
    }
  }

  return (
    <Dialog open={isOpen} onOpenChange={(o) => !saving && !o && onClose()}>
      <DialogContent className="sm:max-w-sm">
        <DialogHeader>
          <DialogTitle>Finalizar cargo</DialogTitle>
        </DialogHeader>

        <div className="space-y-4 py-2">
          <p className="text-sm text-muted-foreground">
            Finalizar el cargo de{" "}
            <span className="font-medium text-foreground">{personName}</span> como{" "}
            <span className="font-medium text-foreground">
              {authority.position_type.name}
            </span>
            .
          </p>

          <div className="space-y-1.5">
            <label className="text-sm font-medium">Fecha de término</label>
            <input
              type="date"
              value={endedAt}
              onChange={(e) => setEndedAt(e.target.value)}
              disabled={saving}
              className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring"
            />
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={saving}>
            Cancelar
          </Button>
          <Button variant="destructive" onClick={handleSave} disabled={saving}>
            {saving && <Loader2 className="mr-2 size-4 animate-spin" />}
            Finalizar cargo
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
